exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.__em-textarea textarea[readonly=\"readonly\"] {\r\n    resize: none;\n}\n.emapm-form.emapm-form-readonly  .mint-cell-group .mint-cell-group-content .emapm-item .__em-textarea  .mint-cell .mint-cell-wrapper{\r\n    align-items:baseline !important;\n}\r\n/* .emapm-form.emapm-form-readonly  .mint-cell-group .mint-cell-group-content .emapm-item .__em-textarea.__em-textarea-readonly {\r\n    background-color:#345678;\r\n} */\r\n/* .__em-textarea .mint-cell-wrapper {\r\n    align-items: baseline;\r\n} */\n.__em-textarea .mint-textarea .mint-cell-wrapper .mint-cell-value{\r\n    width:100%;\n}\n.mt-cell-diy-span {\r\n    word-break: break-all;\r\n    /* text-align: right; */\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-494f7909!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/emapm-form/emapComponents/emTextarea.vue
// module id = 169
// module chunks = 0